/*
 * Copyright (c) 2026, Gather
 * https://gather.life
 */

'use client';

import { Box, type SxProps, type Theme } from '@mui/material';
import { type ReactNode } from 'react';

import { AppSpacing } from '@/theme/constants/app-spacing.constants';
import { ZIndex } from '@/theme/constants/z-index.constants';

import { useNotificationProvider } from '../notification-provider.component';

import { NotificationToast } from './notification-toast.component';
import { type NotificationDisplayProps } from './notification-toast.interface';

const toastContainerStyles: SxProps<Theme> = {
  bottom: AppSpacing.LG,
  left: '50%',
  padding: AppSpacing.MD,
  position: 'fixed',
  transform: 'translateX(-50%)',
  width: { base: `calc(100vw - ${AppSpacing.XLG})`, md: '480px', sm: '400px' },
  zIndex: ZIndex.toast,
};

export function FixedBottomToast({ containerSx, ...props }: NotificationDisplayProps): ReactNode {
  const { notifications } = useNotificationProvider();

  if (!notifications?.length) {
    return;
  }

  return (
    <Box sx={[toastContainerStyles, ...(Array.isArray(containerSx) ? containerSx : [containerSx])]}>
      <NotificationToast {...props} />
    </Box>
  );
}
